import Repository from './Repository';

export default class SettingRepository extends Repository {
    protected basePath = 'settings';

    protected messages = {
        update : this.__('Beállítások sikeresen mentve.'),
    }

    public update(data: object, params: object = null, config: object = null): Promise {
        return new Promise((resolve, reject) => {
            this.request.put(this.buildPath(this.basePath, params), data, config)
                .then((response : any) => {
                    this.request.message = this.messages.update;
                    this.request.status = 200;
                    this.request.title = this.__('Siker');

                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    }
}
